import type { Tubings } from "gql/api";
import type { Maybe } from "graphql/jsutils/Maybe";

export function computeTubingLabel(
  tubing: Maybe<Partial<Tubings>>,
  metric?: boolean
): string {
  if (tubing) {
    if (metric && tubing.metric_name) {
      return `${tubing.metric_name}, ${tubing.imperial_name}`;
    }
    return `${tubing.imperial_name}, ${tubing.metric_name}`;
  }

  return "";
}
